// The gate shows the splash before Modern's provider has loaded the tokens.
import '@modern/theme/resellers/active/tokens.css';

import { useTranslation } from 'react-i18next';

import styles from '@modern/components/ui/splash/splash.module.css';
import type { TModernSplashProps } from '@modern/components/ui/splash/splash.types';

export const ModernSplash = ({ label }: TModernSplashProps) => {
  const { t } = useTranslation();

  return (
    <div
      aria-label={label ?? t('common:loading')}
      className={styles.screen}
      role="status"
    >
      <span className={styles.mark} />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
};
